import {
	connect
} from 'react-redux'
import DataTable from '../components/common/DataTable.jsx';
import {
	findCustomerList, changeCustomerActivePage, deleteCustomer, openCustomerModal, findCustomer
} from '../actions';

function checkShowCheckBox(roles) {
	return roles.includes("ROLE_FIREFIGHTER_CUSTOMER_CRUD");
}

function checkDisableAdd(roles) {
	return !(roles.includes("ROLE_FIREFIGHTER_CUSTOMER_CRUD"));
}

function checkDisableEdit(roles) {
	return !(roles.includes("ROLE_FIREFIGHTER_CUSTOMER_CRUD"));
}

const mapStateToProps = (state) => ({
	data: state.getIn(['customerListReducer', 'customerList']),
	activePage: state.getIn(['customerListReducer', 'activePage']),
	itemPerPage: state.getIn(['customerListReducer', 'itemPerPage']),
	totalPage: state.getIn(['customerListReducer', 'totalPage']),
	searchWord: state.getIn(['customerListReducer', 'searchWord']),
	pagingMaxButtons: 5,
	fields: {
		customer_id: '客戶代號',
		customer_name: '客戶名稱',
		contact: '聯絡人',
		phone: '電話'
	},
	keys: ['customer_id'],
	searchKeys: ['customer_id', 'customer_name'],
	showCheckBox: checkShowCheckBox(state.getIn(['authReducer', 'roles']).toJS()),
	disableAdd: checkDisableAdd(state.getIn(['authReducer', 'roles']).toJS()),
	disableEdit: checkDisableEdit(state.getIn(['authReducer', 'roles']).toJS()),
})

const mapDispatchToProps = (dispatch) => ({
	refresh: (pagingData) => {
		dispatch(findCustomerList(pagingData));
	},
	changeActivepage: (pagingData, searchData) => {
		dispatch(changeCustomerActivePage(pagingData));
		dispatch(findCustomerList(pagingData, searchData));
	},
	deleteItems: (deleteKey, pagingData) => {
		dispatch(deleteCustomer(deleteKey, pagingData));
	},
	openAddModal: () => {
		dispatch(openCustomerModal({ forInsert: true }));
	},
	handleEdit: (pk) => {
		dispatch(findCustomer(pk));
		dispatch(openCustomerModal({ forInsert: false }));
	},
	search: (pagingData, searchData) => {
		dispatch(findCustomerList(pagingData, searchData));
	}
})

const CustomerListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(DataTable)

export default CustomerListContainer;


// WEBPACK FOOTER //
// ./src/containers/CustomerListContainer.jsx